"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Documents.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Documents = function Documents(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 198 248"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Documents Icon"), _react2.default.createElement("path", {
    className: "document",
    d: "M183.91 0H75.12L0 72.51v161.63A13.9 13.9 0 0 0 13.68 248h170.23c7.51 0 14.09-6.35 14.09-13.86V13.71C198 6.2 191.41 0 183.91 0zM83 19.42V73H26.75zM178 229H19V93h83V19h76v210z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Documents;